/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

export const BreadcrumbItemStyled = styled.span`
  & span {
    font-weight: normal;
  }
`;
